import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-white py-12 px-6 border-t border-white/10" data-id="element-82">
      <div className="max-w-[1100px] mx-auto" data-id="element-83">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-84">
          {/* Left Column */}
          <div data-id="element-85">
            <h3 className="text-xl font-outfit font-bold mb-4" data-id="element-86">
              Xander Winther Financial
            </h3>
            <p className="text-gray-400 text-sm max-w-sm leading-relaxed" data-id="element-87">
              Indexed Universal Life insurance strategies for tax-efficient
              retirement and long-term family protection.
            </p>
          </div>

          {/* Right Column */}
          <div className="md:text-right flex flex-col md:items-end justify-center space-y-2" data-id="element-88">
            <a href="tel:602-786-8182" className="text-gray-300 hover:text-white transition-colors" data-id="element-89">
              602-786-8182
            </a>
            <a href="mailto:info@wintherwealth.com" className="text-gray-300 hover:text-white transition-colors" data-id="element-90">
              info@wintherwealth.com
            </a>
            <a href="#" className="text-copper hover:text-[#D49060] transition-colors text-sm font-medium pt-2" data-id="element-91">
              Privacy Policy
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center" data-id="element-92">
          <p className="text-gray-500 text-xs" data-id="element-93">
            © 2026 Xander Winther Financial. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}